<script>
  import { HStack, VStack, Spacer } from "../layout";

  export let step;
  export let current;
  export let maxStep;
</script>

<section class:current={current == step.id} class:done={step.done}>
  <Spacer />
  <div class="icon">
    {#if step.id > 1}
      <span class="liner" class:done={step.done} />
    {:else}
      <Spacer />
    {/if}
    <div class="step">{step.id}</div>
    {#if step.id < maxStep}
      <span class="liner" class:done={step.done} />
    {:else}
      <Spacer />
    {/if}
  </div>
  <Spacer />
  <label for="">{step.name}</label>
</section>
{#if step.id < maxStep}
  <span class="liner" class:done={step.done} />
{/if}

<style>
  section {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    max-width: 100px;
  }
  label {
    font-family: "Cinzel";
    font-size: small;
    min-height: 3em;
    /*overflow: hidden;*/
  }
  .icon {
    display: flex;
    flex-direction: row;
  }

  .current .step {
    background-color: white;
    border: 4px solid var(--secondary-light-color);
    width: 62px;
    height: 62px;
    line-height: 62px;
  }

  .done .step {
    background-color: var(--primary-light-color);
  }

  .step {
    width: 56px;
    height: 56px;
    font-size: x-large;
    /* border: 3px solid #e4e4e4; */
    border-radius: 50%;
    background-color: #e4e4e4;
    color: var(--primary-xx-dark-color);
    text-align: center;
    align-self: center;
    line-height: 56px;
  }

  .current label {
    color: var(--secondary-light-color);
  }

  .liner {
    border-bottom: 2px solid #e4e4e4;
    height: 34px;
    width: auto;
    flex-grow: 1;
    align-self: stretch;
  }
  .icon .liner {
    height: 0;
    align-self: center;
  }
  .current .liner {
    border-color: var(--secondary-light-color);
  }
  .done.liner {
    border-color: var(--primary-light-color);
  }

  @media screen and (max-width: 600px) {
    .current .step {
      width: 42px;
      height: 42px;
      line-height: 42px;
    }
    .step {
      width: 36px;
      height: 36px;
      font-size: large;
      line-height: 36px;
    }
    .liner {
      height: 24px;
    }
    section {
      max-width: 80px;
    }
    label {
      font-size: 12px;
    }
  }
</style>
